import { Component, Input } from '@angular/core';

import { InputBaseComponent } from '../input.base';

@Component({
  selector: 'app-input-range',
  templateUrl: './input-range.component.html',
  styleUrls: ['./input-range.component.scss', './../input.base.scss']
})
export class InpuRangeComponent extends InputBaseComponent {
  @Input() public min: number | null = 0;
  @Input() public max: number | null = 100;
  @Input() public step = 1;
  @Input() public customLabel: string | null = null;

  public get rangeFillPercent(): string {
    const min = this.min ?? 0;
    const max = this.max ?? 100;
    const value = Number(this.inputControl?.value ?? min);

    if (max <= min) {
      return '0%';
    }

    const percent = ((value - min) / (max - min)) * 100;
    const clampedPercent = Math.min(100, Math.max(0, percent));

    return `${clampedPercent}%`;
  }
}
